import React, { useEffect, useState } from "react";
import { getTotalTracksCount } from "../../services/trackService";
import { TotalTrackCountProps } from "./types";
import { GetTotalTracksAndFilesCountResponse } from "../../proto/api_pb";

const TotalTracksCount: React.FC<TotalTrackCountProps> = ({
  getValidAccessToken,
  userId,
  enterpriseId,
  isCountUpdated,
  setIsCountUpdated,
}) => {
  const [trackCount, setTrackCount] = useState<number>(0);
  const [filesCount, setFilesCount] = useState<number>(0);

  useEffect(() => {
    const getCount = async () => {
      if (!enterpriseId || !userId) return;
      try {
        const token = await getValidAccessToken();
        const response = await getTotalTracksCount(token, userId, enterpriseId);
        if (response instanceof GetTotalTracksAndFilesCountResponse) {
          setTrackCount(response.getTracksCount());
          setFilesCount(response.getFilesCount());
        } else {
          setTrackCount(0);
        }
      } catch (error) {
        console.error("Error fetching track count:", error);
        setTrackCount(0);
      }
      if (isCountUpdated && setIsCountUpdated) {
        setIsCountUpdated(false);
      }
    };

    getCount();
  }, [
    enterpriseId,
    userId,
    getValidAccessToken,
    isCountUpdated,
    setIsCountUpdated,
  ]);


  return (
    <span style={{ fontSize: "1.5rem", fontWeight: "normal" }}>
      {(trackCount > 0 || filesCount > 0) && (
        <>
          ({trackCount > 0 && `${trackCount} Tracks`}
          {trackCount > 0 && filesCount > 0 && " & "}
          {filesCount > 0 && `${filesCount} Files`})
        </>
      )}
    </span>
  );
};

export default TotalTracksCount;
